var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsAiassistantDeepanalysisIcon = function SvgNewcsAiassistantDeepanalysisIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".newcs_aiassistant_deepanalysis_icon_svg__cls-2{stroke-miterlimit:10;stroke:currentColor;stroke-width:.2px;fill:currentColor}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8c0-.3.24-.54.54-.54s.54.24.54.54c0 3.27 2.66 5.92 5.92 5.92 2.11 0 4.07-1.14 5.13-2.96a.541.541 0 1 1 .94.54A7.02 7.02 0 0 1 8.01 15c-3.86 0-7-3.14-7-7ZM1.71 5.04c0-.08.02-.17.06-.25A6.99 6.99 0 0 1 8 .99c3.86 0 7 3.14 7 7 0 .3-.24.54-.54.54s-.54-.24-.54-.54A5.926 5.926 0 0 0 2.73 5.28c-.14.26-.46.37-.73.23a.53.53 0 0 1-.29-.48Z",
    className: "newcs_aiassistant_deepanalysis_icon_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.81 11.16c0-.3.24-.54.54-.54h2.33c.3 0 .55.24.55.54v2.33c0 .3-.25.54-.55.54s-.55-.24-.55-.54v-1.8h-1.78c-.3 0-.54-.24-.54-.54ZM1.61 5.13V2.8c0-.3.24-.54.54-.54s.54.24.54.54v1.8h1.79c.3 0 .54.24.54.54s-.24.54-.54.54H2.15a.53.53 0 0 1-.53-.54Z",
    className: "newcs_aiassistant_deepanalysis_icon_svg__cls-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.37 9.18 6.7 7.32c.06-.05.16-.05.21.01L8.5 8.97c.07.06.17.06.24 0l2.9-2.15",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: "1.4px",
      strokeMiterlimit: 10
    }
  }));
};
export default SvgNewcsAiassistantDeepanalysisIcon;